import { render, staticRenderFns } from "./jiliangService.vue?vue&type=template&id=590bf783&scoped=true"
import script from "./jiliangService.vue?vue&type=script&lang=js"
export * from "./jiliangService.vue?vue&type=script&lang=js"
import style0 from "./jiliangService.vue?vue&type=style&index=0&id=590bf783&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590bf783",
  null
  
)

export default component.exports